var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProjectInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 9.49999L8.73167 13.1158C8.83006 13.165 8.87925 13.1896 8.93085 13.1993C8.97655 13.2079 9.02345 13.2079 9.06915 13.1993C9.12075 13.1896 9.16994 13.165 9.26833 13.1158L16.5 9.49999M1.5 13.25L8.73167 16.8658C8.83006 16.915 8.87925 16.9396 8.93085 16.9493C8.97655 16.9579 9.02345 16.9579 9.06915 16.9493C9.12075 16.9396 9.16994 16.915 9.26833 16.8658L16.5 13.25M1.5 5.74999L8.73167 2.13415C8.83006 2.08496 8.87925 2.06036 8.93085 2.05068C8.97655 2.04211 9.02345 2.04211 9.06915 2.05068C9.12075 2.06036 9.16994 2.08496 9.26833 2.13415L16.5 5.74999L9.26833 9.36582C9.16994 9.41502 9.12075 9.43961 9.06915 9.44929C9.02345 9.45787 8.97655 9.45787 8.93085 9.44929C8.87925 9.43961 8.83006 9.41502 8.73167 9.36582L1.5 5.74999Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectInactive);
export default __webpack_public_path__ + "static/media/project-inactive.91e9387cc1d2194e11b457a28cad3782.svg";
export { ForwardRef as ReactComponent };